import { createContext, useContext } from "react";
import { useFilter } from "../../../../../hooks/filter";
import { FilterBody } from "../../../../../hooks/filter/typing";

const CompanyContext = createContext<{
    filterCompany: FilterBody
}>(Object({}))
export const useCompanyContext = () => useContext(CompanyContext)

export const CompanyContextProvider = ({ children }: { children: JSX.Element }) => {
    const filterCompany = useFilter({
        formatFilter: {
            search: 'search',
            from: 'start_date',
            to: 'end_date',
            createYear: 'year',
            month: 'month',
            status: "status_ids",
        },
    })
    return (
        <CompanyContext.Provider value={{
            filterCompany
        }}>
            {children}
        </CompanyContext.Provider>
    )
}